import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { PageHeader } from '@/components/layout';
import { Button, Badge, TableSkeleton } from '@/components/ui';
import { ApiErrorDisplay } from '@/components/features/error';
import { IqServiceList } from '@/components/features/iq-services';
import { useIqServices } from '@/hooks';

/**
 * IQ-Services list page.
 * Route: /iq-services (platform_admin only)
 */
export function IQServicesPage() {
  const { t } = useTranslation('iq-services');
  const navigate = useNavigate();
  const { data, isLoading, error } = useIqServices();

  if (isLoading) {
    return (
      <div>
        <PageHeader
          title={t('page.title')}
          description={t('page.description')}
        />
        <TableSkeleton rows={5} cols={3} />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageHeader
          title={t('page.title')}
          description={t('page.description')}
        />
        <ApiErrorDisplay error={error} />
      </div>
    );
  }

  const services = data?.data ?? [];

  return (
    <div>
      <PageHeader
        title={t('page.title')}
        description={t('page.description')}
        actions={
          <div className="flex items-center gap-3">
            <Badge variant="info">
              {t('list.serviceCount', { count: services.length })}
            </Badge>
            <Button size="sm" onClick={() => navigate('/iq-services/new')}>
              <Plus className="mr-2 h-4 w-4" />
              {t('list.create')}
            </Button>
          </div>
        }
      />

      <IqServiceList services={services} />
    </div>
  );
}
